export default function CrossCircle() {
  return (
    <>
      <path
        d='M14.0312 14.0312L26.9688 26.9688M26.9688 14.0312L14.0312 26.9688'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
